export class InvalidRestaurantsStatus extends Error {
  constructor(orderId, status) {
    super(`Order ${orderId} has invalid restaurant status: ${status}`);
  }
}
//# sourceMappingURL=order.js.map